// material-ui
// third party
// project imports
import React from "react";
import { Button, Grid, Stack } from "@mui/material";
import { CheckCircleTwoTone } from "@mui/icons-material";
import { FormattedMessage } from "react-intl";
import AnimateButton from "../../../../../ui-component/components/AnimateButton";
import { useNavigate } from "react-router-dom";

interface Props {
    handleDrawerChangeState: () => void;
}

// ==============================|| MEMBERS - FORM FOR EDIT/VIEW ||============================== //

interface Props {
    handleDrawerChangeState: () => void;
    setSuccessResult: any;
    rechargedMemberId: string;
}

const SuccessResult = ({ handleDrawerChangeState, setSuccessResult, rechargedMemberId }: Props) => {
    const navigate = useNavigate();

    return (
        <>
            <Grid container>
                <Grid item xs={12} style={{ textAlign: 'center', margin: '16px 0' }}>
                    <CheckCircleTwoTone style={{ fontSize: '3.5em' }} />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'center', marginBottom: '48px' }}>
                    La ricarica è stata eseguita con <b>successo</b>! Puoi inserire una nuova ricarica oppure entrare
                    nel dettaglio del socio.
                </Grid>
                <Grid item xs={12}>
                    <Stack direction="row" justifyContent={'space-between'}>
                        <Button onClick={() => setSuccessResult(false)} sx={{ my: 3, ml: 1 }}>
                            <FormattedMessage id={'SYS00023'} />
                        </Button>
                        <AnimateButton>
                            <Button variant="contained"
                                    onClick={() => {
                                        handleDrawerChangeState()
                                        navigate('/anagrafiche/tutori/dettaglio/' + rechargedMemberId)
                                    }}
                                    sx={{ my: 3, ml: 1 }}>
                                <FormattedMessage id={'FRM00095'} />
                            </Button>
                        </AnimateButton>
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
};
export default SuccessResult;